import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefVerificationLimit } from './interface/IRefVerificationLimit';

@Entity('ref_veerification_limit')
export class RefVerificationLimit extends BaseEntity implements IRefVerificationLimit{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
